import GuideModel from '../../../../models/GuideModel';
import { collectGuideSignals } from './conversationFlowTools';

const CACHE_KEY = 'guides';
const cache = new Map();
const inFlight = new Map();

export const fetchGuideSignals = () => {
  if (cache.has(CACHE_KEY)) {
    return Promise.resolve(cache.get(CACHE_KEY));
  }

  const pending = inFlight.get(CACHE_KEY);
  if (pending) return pending;

  const request = collectGuideSignals({
    listGuides: (params) => GuideModel.get(params),
    findGuide: (id) => GuideModel.findById(id)
  }).then((signals) => {
    cache.set(CACHE_KEY, signals);
    inFlight.delete(CACHE_KEY);
    return signals;
  }).catch((error) => {
    inFlight.delete(CACHE_KEY);
    throw error;
  });

  inFlight.set(CACHE_KEY, request);
  return request;
};

export const invalidateGuideSignalsCache = () => {
  cache.delete(CACHE_KEY);
  inFlight.delete(CACHE_KEY);
};
